import React from "react";
import Button from "react-bootstrap/Button";
import Shape from '../images/Shape.png';
import Rectangle from '../images/Rectangle.png';
import Webcam from 'react-webcam';
import Footer from "./reusable-components/footer";
import { Link } from 'react-router-dom';

function scan() {
    return (
        <div className="App"
            style={{
                width: '100%',
                height: '753px',
                backgroundColor: '#F9F9F9',
                textAlign: 'center'
            }}>
            <div className="topBar"
                style={{ padding: '13px' }}>

                <img src={Shape} style={{ width: '65px', height: '17px' }} alt="" />
            </div>
            <div >
                <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
            </div>
            <div style={{
                fontFamily: 'Sintony',
                backgroundColor: '#F9F9F9',
                marginTop: '10px'
            }}>
                <span
                    style={{
                        fontSize: '14px',
                        color: '#2E2E2E',
                        textAlign: 'center'
                    }}>
                    Please Scan the barcode on your package.
                </span>
                <div style={{
                    border: '1px solid',
                    borderColor: 'red',
                    backgroundColor: '#F9F9F9',
                }}>
                    <Webcam height={240
                    } width={415} />
                </div>
                <div style={{
                    fontFamily: 'Sintony',
                    textAlign: 'center',
                    marginTop: '15px',
                    marginBottom: '10px'
                }}>
                    <span
                        style={{
                            fontSize: '14px',
                            color: '#2E2E2E',
                            fontWeight: 'bold'
                        }}>
                        Registration Code: ############
                    </span>
                    <p style={{
                        fontSize: '13px'
                    }}>
                        <br></br>
                        If you know your code you can skip and enter it manually in the registration page.
                    </p>
                </div>
            </div>
            <div
                style={{
                    backgroundColor: '#F9F9F9',
                    marginBottom: '15px'
                }}>
                <Link to="/device-registration">
                    <Button variant="success" size="lg" type="submit" style={{
                        height: '35px',
                        width: '153px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        borderRadius: '0',
                        color: '#FFFFFF',
                        backgroundColor: '#00A78A'
                    }}>
                        SKIP SCAN
                    </Button>
                </Link> *
            </div>
            <div>
                <Footer />
            </div>
        </div >
    );
}

export default scan;